interface OrderedColorSets {
  [key: string]: string[];
}

export const mcqColor = '#55a6ff';

export const compareColorSet: OrderedColorSets = {
  1: ['#55dfd8'],
  2: ['#ff4a7a', '#55dfd8'],
  3: ['#ff4a7a', '#d0d1d1', '#55dfd8'],
  4: ['#ff4a7a', '#e0a5b4', '#a8d6d3', '#55dfd8'],
  5: ['#ff4a7a', '#e88fa6', '#d1d2d2', '#94d9d5', '#55dfd8'],
  6: ['#ff4a7a', '#ec819d', '#dab6c0', '#b8d4d2', '#87dad6', '#55dfd8'],
  7: ['#ff4a7a', '#f07898', '#e1a5b5', '#d2d1d1', '#a8d6d4', '#7fdbd6', '#55dfd8'],
  8: ['#ff4a7a', '#f27193', '#e598ac', '#d7bec5', '#bfd3d2', '#9cd7d4', '#79dcd7', '#58e8e0'],
  9: ['#ff4a7a', '#f46c90', '#e88ea6', '#ddafbb', '#d1d1d1', '#b2d5d3', '#93d8d5', '#74dcd7', '#58e8e0'],
  10: [
    '#ff4a7a',
    '#f4688d',
    '#eb86a1',
    '#e0a4b4',
    '#d6c2c8',
    '#c4d3d2',
    '#a9d7d4',
    '#8cd9d5',
    '#71ddd8',
    '#55dfd8',
  ],
  11: [
    '#ff4a7a',
    '#f5658b',
    '#ec809d',
    '#e39bae',
    '#dab6c0',
    '#d1d1d1',
    '#b9d4d3',
    '#a0d7d5',
    '#87dad6',
    '#6eddd7',
    '#55dfd8',
  ],
};
